import $ from 'jquery';
import Vue from 'vue';
import vueSlider from 'vue-slider-component';

let priceRangeMax = null;

const initWowFilterPriceRangeB = (elementId, priceRangeMax) => {
  new Vue({
    el: `#${elementId}`,
    components: {
      vueSlider
    },
    data: () => {
      return {
        priceRangeMax,
        value: [
          0,
          priceRangeMax
        ],
      }
    },
    methods: {
      onDragEnd: (e) => {
        var event = new CustomEvent('tx.filter.willUpdate', {
          detail:{
            param:{
              pricemin: e.value[0],
              pricemax: e.value[1]
            }
          }
        })
        document.dispatchEvent(event)
      }
    },
    mounted: () => {

    }
  });
}

(()=>{
  const initFilter = () => {
    if (window.FILTERS &&
      window.FILTERS.price &&
      window.FILTERS.price[window.FILTERS.price.length-1] && 
      window.FILTERS.price[window.FILTERS.price.length-1].price_range_max ) {
      priceRangeMax = window.FILTERS.price[window.FILTERS.price.length-1].price_range_max + 5000
    }
  
    if($('.vue-wow-filter-price-range-b').length){
      if( priceRangeMax ){
        $('.vue-wow-filter-price-range-b').each(function(){
          const isInit = $(this).attr('data-is-init')
          if (isInit == true) { return }
          $(this).attr('data-is-init', true)
          const wowFilterPriceRangeBid = $(this).attr('id')
          initWowFilterPriceRangeB(wowFilterPriceRangeBid, priceRangeMax)
        })
      }
    }
  
    $('.js-toggle-expand-button').each(function() {
      const isInit = $(this).attr('data-is-init')
      if (isInit == true) { return }
      $(this).attr('data-is-init', true)
      const counter = $(this).parent('div').parent('div').find('table tr').not('.hidden').length;
      if(counter > 6){
        $(this).parent('div').removeAttr('hidden');
      }
    });
  
    $('.js-toggle-expand-button').unbind('click').click(function() {
      $(this).parent('div').parent('div').toggleClass( "is-expand" );
    });
  }

  $(document).ready(()=>{
    initFilter()
  })

  document.addEventListener('wow-dd.filter.init', () => {
    initFilter()
  }, false);
})()